import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedModule } from '@modules/shared.module';
import { LoginService } from '@services/login/login.service';
import { NavigationService } from '@services/navigation-service/navigation-service.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { UsuarioService } from '@services/usuario/usuario.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-input-otp',
  standalone: true,
  imports: [SharedModule],
  templateUrl: 'input-otp.component.html',
  styleUrls: ['./input-otp.component.css'],
})
export class InputOtpComponent {
  @Input() length: number = 6; // Longitud del OTP
  @Input() idUsuario!: number; // Longitud del OTP
  @Output() otpComplete = new EventEmitter<string>();

  otp: string[] = [];
  activeIndex: number = 0;
  otpInputs: Array<number> = [];
  tiempoRestante: number = 60;
  intervalo: any;
  isDisabled: boolean = true; // Inicialmente deshabilitado

  constructor(
    //private UsuarioService: UsuarioService,
    private router: Router,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private loginService: LoginService,
    private usuarioService: UsuarioService,
    private route: ActivatedRoute
  ) {



  }
  ngOnInit() {
    this.otp = Array(this.length).fill('');
    this.otpInputs = new Array(this.length);
    this.iniciarTemporizador();
  }

  // Maneja el cambio en la entrada
  onInputChange(index: number) {
    if (this.otp[index] && index < this.length - 1) {
      this.activeIndex = index + 1;
    }
    this.checkOtpComplete();
  }


  // Método para borrar todos los campos OTP
  clearOtp() {
    this.otp = Array(this.length).fill('');
    this.activeIndex = 0;  // También restablecer el índice activo al primer campo
  }

  // Detecta si el OTP está completo
  checkOtpComplete() {
    const otpString = this.otp.join('');
    if (otpString.length === this.length) {
      this.otpComplete.emit(otpString);
    }
  }

  // Maneja la navegación con las teclas de flecha
  onKeyDown(event: KeyboardEvent, index: number) {
    if (event.key === 'Backspace' && !this.otp[index] && index > 0) {
      this.activeIndex = index - 1;
    } else if (event.key === 'ArrowLeft' && index > 0) {
      this.activeIndex = index - 1;
    } else if (event.key === 'ArrowRight' && index < this.length - 1) {
      this.activeIndex = index + 1;
    }
  }

  // Permite pegar código en los campos de OTP
  onPaste(event: ClipboardEvent, index: number) {
    const pasteData = event.clipboardData?.getData('text') || '';
    const otpData = pasteData.split('').slice(0, this.length);
    this.otp = otpData;

    // Enfoca el último campo que ha sido pegado
    this.activeIndex = otpData.length < this.length ? otpData.length : this.length - 1;
    this.checkOtpComplete();
  }


  iniciarTemporizador() {
    clearInterval(this.intervalo);
    this.intervalo = setInterval(() => {
      if (this.tiempoRestante > 0) {
        this.tiempoRestante--;
      } else {
        this.isDisabled = false;
      }
    }, 1000);
  }

  onLinkClick(event: Event) {
    console.log("Reenvio de token")
    this.isDisabled = true;
    this.tiempoRestante = 120;
    this.iniciarTemporizador();
    this.resendVerificationCodeCorreo();
  }

  reenviarCodigo() {
    console.log('Código reenviado automáticamente');
    this.tiempoRestante = 60;
  }

  ngOnDestroy() {
    clearInterval(this.intervalo);
  }

  resendVerificationCodeCorreo() {
    if (this.idUsuario) {
      this.spinner.show('spVerifyCodeCorreo')
      this.usuarioService.resendVerificationCodeCorreo(this.idUsuario)
        .subscribe(
          data => {
            this.spinner.hide('spVerifyCodeCorreo')
            this.snackBar.showSuccess("En breve recibirás un nuevo código en tu correo para validar tu cuenta y avanzar al siguiente paso.", "Exito");
          },
          error => {
            this.spinner.hide('spVerifyCodeCorreo')
            this.snackBar.showError(error, "Error");
          })
    }
  }
}

